import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

const MarkdownContainer = styled.div`
  blockquote {
    margin-left: 0;
    padding: 0 0 0 ${pxToRem(20)};
    border-left: ${pxToRem(2)} solid;
  }
  code {
    font-family: Menlo, Monaco, Consolas, 'Lucida Console', monospace;
  }
`;

type Props = {
  className: string;
  source: string;
};

const Markdown = ({ className, source }: Props) => {
  return (
    <MarkdownContainer className={className}>
      <ReactMarkdown>{source}</ReactMarkdown>
    </MarkdownContainer>
  );
};

export default Markdown;
